import { instantMeiliSearch, InstantMeiliSearchInstance } from "@meilisearch/instant-meilisearch";
import { isLocalhost } from "serviceWorker";
const address = isLocalhost
  ? "http://localhost:7700"
  : window.location.origin + process.env.REACT_APP_SEARCH_URL;
export const searchEngineAccessKey = "search-engine-key";
export const getInstantSearchInstance: (key: string) => InstantMeiliSearchInstance = (
  key: string
) =>
  instantMeiliSearch(address, key, {
    paginationTotalHits: 1000,
    primaryKey: "id"
  });
